'use client'

import { useTrailerViewMedia } from '@/hooks/useTrailerViewMedia'
import { createContext, PropsWithChildren, useContext } from 'react'

const TrailerViewMediaContext = createContext<ReturnType<typeof useTrailerViewMedia> | null>(null)

export function TrailerViewMediaProvider({ children }: PropsWithChildren) {
  const value = useTrailerViewMedia()

  return (
    <TrailerViewMediaContext.Provider value={value}>{children}</TrailerViewMediaContext.Provider>
  )
}

export const useTrailerViewMediaContext = () => {
  const value = useContext(TrailerViewMediaContext)

  if (value == null) {
    throw new Error('useTrailerViewMediaContext cannot be used outside of TrailerViewMediaProvider')
  }

  return value
}
